module.exports = __webpack_public_path__ + "static/media/clip-selected.73fe40c8.jpg";